module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/assessment_achievements/4_124559064c2554c732ecb510f115a955.jpg";